export class Routes {
  static login = "/login";

  static home = "/";

  //---------------------- start events ----------------------//

  static events = "/events";

  static addEvent = `${this.events}/add`;

  static event = `${this.events}/:eventId`;

  static getEvent = (id: any) => `${this.events}/${id}`;

  static editEvent = `${this.event}/edit`;

  static getEditEvent = (id: any) => `${this.getEvent(id)}/edit`;

  //---------------------- end events ----------------------//

  //---------------------- start directories ----------------------//

  static directories = "/directories";

  static addDirectory = `${this.directories}/add`;

  static directory = `${this.directories}/:directoryId`;

  static getDirectory = (id: any) => `${this.directories}/${id}`;

  static editDirectory = `${this.directory}/edit`;

  static getEditDirectory = (id: any) => `${this.getDirectory(id)}/edit`;

  //---------------------- end directories ----------------------//

  //---------------------- start ar-games ----------------------//
  static games = "/games";

  static game = `${this.games}/:gameId`;
  static getGame = (id: any) => `${this.games}/${id}`;

  static locations = "/locations";

  static addLocation = `${this.locations}/:gameId/add`;

  static getAddLocation = (id: any) => `${this.locations}/${id}/add`;

  static getLocation = (gameId: any, id: any) =>
    `${this.locations}/${gameId}/${id}`;

  static editLocation = `${this.locations}/:gameId/:locationId/edit`;

  static getEditLocation = (gameId: any, id: any) =>
    `${this.getLocation(gameId, id)}/edit`;
  //---------------------- end ar-games ----------------------//

  //---------------------- start inbox ----------------------//

  static tenantCommunityInbox = "/inbox";

  static addTenantCommunityInboxPost = `${this.tenantCommunityInbox}/add`;

  static tenantCommunityInboxPost = `${this.tenantCommunityInbox}/:postId`;

  static getTenantCommunityInboxPost = (id: any) => `${this.tenantCommunityInbox}/${id}`;

  static editTenantCommunityInboxPost = `${this.tenantCommunityInboxPost}/edit`;

  static getEditTenantCommunityInboxPost = (id: any) => `${this.getTenantCommunityInboxPost(id)}/edit`;

  //---------------------- end inbox ----------------------//
}
